// extracted by mini-css-extract-plugin
module.exports = {"simpleLayout":"Layout_simpleLayout__uZhQI","simpleForm":"Layout_simpleForm__4pLsf"};